

export class RegistryEntry{
    constructor(name, createFn){
        var _name = name;
        var _createFn = createFn;
        var _eventDefineListeners = [];
        var _component;

        Object.defineProperty(this,'name',{
            set : (name)=>{ _name = name},
            get: ()=>_name  
        });


        Object.defineProperty(this,'createFn',{
            get: ()=>_createFn 
        });

        Object.defineProperty(this,'addEventDefineListener',{
            value: (eventDefineListener)=>_eventDefineListeners.push(eventDefineListener) 
        });

        Object.defineProperty(this,'clearEventDefineListener',{
            value : () => _eventDefineListeners = []
        })

        Object.defineProperty(this,'getEventDefineListeners',{
            value: ()=>_eventDefineListeners
        });

        Object.defineProperty(this,'component',{
            set : (component)=>{ _component = component },
            get : ()=>_component
        })


    }
    // ==========
    // public
    // ---------- 
    setName(name){ this.name = name }

    getName(){ return this.name }

    setCreateFn(fn){ this.createFn = fn; }

    getCreateFn(){ return this.createFn }

    getComponent(){ return this.component }

    setComponent(component){ this.component = component; }

    
}